import React, { useEffect, useRef, useState } from "react";
import styles from "./NewsCatalog.module.scss";
import Container from "../Container/Container";
import TitleUnderline from "../TitleUnderline/TitleUnderline";
import Accordion from "../Accordion/Accordion";
import { wordEnding } from "../../helpers/wordEnding";
import Radio from "../Radio/Radio";
import Pagination from "../Pagination/Pagination";
import DefaultButton from "../DefaultButton/DefaultButton";
import { useWindowWidth } from "../../hooks/useWindowWidth";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Hr from "../Hr/Hr";
import CloseIcon from "public/icons/close.svg";
import { NextRouter, useRouter } from "next/router";
import cn from "classnames";
import ArrowIcon from "public/icons/arrow.svg";
import { useAppDispatch, useAppSelector } from "../../store/store";
import Modal from "../Modal";
import NewsCatalogItemPreview from "../NewsCatalogItemPreview/NewsCatalogItemPreview"
import { INewsCategories, INewsCatalog } from "../../interfaces/newsCatalog.interface"
import { newsActions } from "../../store/newsSlice"
import Link from "next/link"
import { axiosServer } from "../../axios/axiosCustom"
import { API_SSR } from "../../api/api"

interface NewsPageProps {
  news: INewsCatalog;
  categories: INewsCategories;
  countNews?: number;
  isLoading: boolean;
}

const NewsCatalog = ({
                       countNews,
                       isLoading,
                       categories,
                       news,
                     }: NewsPageProps) => {
  const [active, setActive] = useState(null);
  const [page, setPage] = useState<number>(1);
  const width = useWindowWidth();
  const [openFilters, setOpenFilters] = useState<boolean>(false);
  const router = useRouter();
  const [openShow, setOpenShow] = useState(false);
  const [pageSize, setPageSize] = useState(12);
  const dispatch = useAppDispatch();

  const [newsList, setNewsList] = useState(news)

  const setSortParam = (sort: string) => {
    router.query.sort = sort
    router.push(router)
  }

  useEffect(() => {
    const fetchNews = async () => {
      const { data: news } = await axiosServer.get<INewsCatalog>(
        API_SSR.getNewsByCategory(
          `sort=${router.query.sort}&per_page=1000`
        )
      );
      setNewsList(news)
    }
    fetchNews()
  }, [router.query]);

  useEffect(() => {
    const modalElement = document.getElementById("modal");
    if (openFilters) {
      disableBodyScroll(modalElement, { reserveScrollBarGap: true });
    } else if (!openFilters) {
      enableBodyScroll(modalElement);
    }
  }, [openFilters]);

  useEffect(() => {
    setActive(categories.data.findIndex((e) => e.slug == router.query.slug));
  }, [router.query]);

  useEffect(() => {
    dispatch(newsActions.setPage(page));
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [page]);

  useEffect(() => {
    dispatch(newsActions.setPageSize(pageSize));
    setPage(1);
  }, [pageSize]);

  return (
    <Container className={styles.container}>
      <TitleUnderline>Новости</TitleUnderline>
      <div className={styles.root}>
        <div className={styles.filtersBody}>
          <div className={styles.singleFilterBody}>
            <h3 className={styles.filtersHeading}>Категории:</h3>
            <ul className={styles.filtersList}>
              <li className={styles.filterListElement}><Link href={`/news/`}>Все</Link></li>
              {categories.data.map((el, i) => (
                  <li className={styles.filterListElement}><Link href={`/news/category/${el.id}`} key={i}>{el.name}</Link></li>
              ))}
            </ul>
          </div>
          <div className={styles.singleFilterBody}>
            <h3 className={styles.filtersHeading}>Сортировка:</h3>
            <ul className={styles.filtersList}>
              <li onClick={() => setSortParam('desc')}>Сначала новые</li>
              <li onClick={() => setSortParam('asc')}>Сначала старые</li>
            </ul>
          </div>
        </div>
        <main className={styles.main}>
          {isLoading ? (
            <div className={styles.loader}></div>
          ) : (<>
            <div className={styles.active}>
              {countNews && <div className={styles.length}>
                {countNews}{" "}
                {wordEnding(countNews, [
                  "новость",
                  "новости",
                  "новостей",
                ])}
              </div>}
              <button
                onMouseLeave={() => setOpenShow(false)}
                className={cn(styles.show, {
                  [styles.activeShow]: openShow,
                })}
                onClick={() => setOpenShow(true)}
              >
                <div>Показывать по: {pageSize}</div>
                <ArrowIcon/>
                {openShow && (
                  <div className={styles.pageSize}>
                    <div onClick={() => setPageSize(12)}>12</div>
                    <div onClick={() => setPageSize(24)}>24</div>
                  </div>
                )}
              </button>
            </div>
            <div className={styles.catalog}>
              {newsList.data.map((e, i) => (
                <NewsCatalogItemPreview key={i} item={e}/>
              ))}
            </div>
            <Pagination
              className={styles.pagination}
              onPageChange={setPage}
              totalCount={countNews}
              siblingCount={1}
              currentPage={page}
              pageSize={pageSize}
            />
            {width < 1279 && openFilters && (
              <Modal
                isOpen={openFilters}
                onRequestClose={() => setOpenFilters(false)}
                className={cn(styles.filtersModal)}
              >
                <div className={styles.header}>
                  <h3 className={styles.filtersTitle}>Фильтры</h3>
                </div>
                <div
                  className={cn(styles.activeButtons, {
                    [styles.openButtons]: true,
                  })}
                >
                  <DefaultButton
                    onClick={() => {
                      setOpenFilters(false);
                    }}
                    className={styles.accept}
                  >
                    Скрыть
                  </DefaultButton>
                </div>
              </Modal>
            )}
          </>)}
        </main>
      </div>
    </Container>
  );
};

export default NewsCatalog;
